(function ($) {
  'use strict';

  //Vytvorenie after submit funkcie, ktorá bude zavolaná po odoslaní formulára na server
  window.generalFormAfterSubmitFunction = function() {
    $().lightbox.create('<span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>', 'lb-loader').hideX();
  };
  //Vytvorenie after response funkcie, zavolaná po prijatí odpovede
  window.generalFormAfterResponseFunction = function() {
    $().lightbox.destroy();
  };

  //Vytvorenie post render funkcie, ktorá bude zavolaná po vyrenderovaní formulára GeneralForms
  window.generalFormPostRenderFunction = function() {

    window.selectOrNative($('.gf-form'));

  };

  //Vytvorenie post render funkcie, ktorá bude zavolaná po vyrenderovaní formulára
  window.globalPostRenderFunction = function(name) {
    var form = null;
    if(name) {
      form = $('form[name="' + name + '"]');
    } else {
      form = $('form');
    }
    if(form.length <= 0)
      return;


    window.selectOrNative(form);
  };

  //Custom funkcia, zavolá sa po každom vyrenderovaní tabuľky - NEJLEVNEJSI LETENKY
  window.airticketOffersTablePostRender = function() {
    //console.log('airticket offers table selectOrNative');
    window.selectOrNative($('#action-offers-table'));

  };

  window.jpSelectAdded = function(wrapper) {
    window.selectOrNative(wrapper);
  }

})(jQuery);